import { render, staticRenderFns } from "./WebPayNotificationItems.vue?vue&type=template&id=c6a93f3c&"
import script from "./WebPayNotificationItems.vue?vue&type=script&lang=js&"
export * from "./WebPayNotificationItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports